import { jsonp, ajax } from '@ifeng-fe/ui_base';
import md5 from 'md5';
import axios from 'axios';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    /* eslint-disable */
    while (typeof window === 'object' && window[jsonpCallbackName]) {
        /* eslint-enable */
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

const getVideoFileKey = async (url, formData, onUploadProgress) => {
    return await axios.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    });
};

const getImgFileKey = async (url, formData) => {
    return await axios.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const getTokenDataColleges2025 = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https://d.shankapi.ifeng.com/api/phtv2025/college/host/sign/upload/${type}/token/${timeStamp}`);
};

const saveMediaFileColleges2025 = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/college/host/sign/${type}/commit/${timeStamp}`, data);
};

const submitFormHandleColleges2025 = async (data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/college/host/sign/commit/${timeStamp}`, data);
};

const updateFormHandleColleges2025 = async (data, updateId) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/college/host/sign/${updateId}/update/${timeStamp}`, data);
};

const getHostHandleColleges2025 = async (updataId) => {
    const timeStamp = new Date().getTime();

    return await axios.get(`https://shankapi.ifeng.com/api/phtv2025/college/host/sign/get/${updataId}/info/${timeStamp}`);
};

// 社会接口
const getTokenDataSociety2025 = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https://d.shankapi.ifeng.com/api/phtv2025/community/host/sign/upload/${type}/token/${timeStamp}`);
};

const saveMediaFileSociety2025 = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/community/host/sign/${type}/commit/${timeStamp}`, data);
};

const submitFormHandleSociety2025 = async (data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/community/host/sign/commit/${timeStamp}`, data);
};

const updateFormHandleSociety2025 = async (data, updateId) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/community/host/sign/${updateId}/update/${timeStamp}`, data);
};

const getHostHandleSociety2025 = async (updataId) => {
    const timeStamp = new Date().getTime();

    return await axios.get(`https://shankapi.ifeng.com/api/phtv2025/community/host/sign/get/${updataId}/info/${timeStamp}`);
};

// 湾区
const getTokenDataArea2025 = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https://d.shankapi.ifeng.com/api/phtv2025/dawanqu/host/sign/upload/${type}/token/${timeStamp}`);
};

const saveMediaFileArea2025 = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/dawanqu/host/sign/${type}/commit/${timeStamp}`, data);
};

const submitFormHandleArea2025 = async (data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/dawanqu/host/sign/commit/${timeStamp}`, data);
};

const updateFormHandleArea2025 = async (data, updateId) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2025/dawanqu/host/sign/${updateId}/update/${timeStamp}`, data);
};

const getHostHandleArea2025 = async (updataId) => {
    const timeStamp = new Date().getTime();

    return await axios.get(`https://shankapi.ifeng.com/api/phtv2025/dawanqu/host/sign/get/${updataId}/info/${timeStamp}`);
};

// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)
// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)
// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)

export {
    getTokenDataColleges2025,
    saveMediaFileColleges2025,
    submitFormHandleColleges2025,
    updateFormHandleColleges2025,
    getHostHandleColleges2025,
    getImgFileKey,
    getVideoFileKey,
    getTokenDataSociety2025,
    saveMediaFileSociety2025,
    submitFormHandleSociety2025,
    updateFormHandleSociety2025,
    getHostHandleSociety2025,
    getTokenDataArea2025,
    saveMediaFileArea2025,
    submitFormHandleArea2025,
    updateFormHandleArea2025,
    getHostHandleArea2025,
};
